<template>
  <v-container fluid class="event-detail-user-list-row">
    <v-layout>
      <div class="list-item">
        <span style="width: 50px">
          <v-avatar size="40px" v-if="!!user.imgUrl">
            <img :src="user.imgUrl" @error="defaultImageProfile" />
          </v-avatar>
          <img
            class="user-icon"
            :style="user.coachOrPlayer === 'Coach' && { height: '20%' }"
            v-if="!user.imgUrl || user.imgUrl === ''"
            :src="
              user.coachOrPlayer === 'Coach' ? icons.coach : icons.player
            " />
        </span>

        <div
          @click="gotToPlayerStatus(user)"
          style="
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          ">
          <div>
            <span>{{ user.firstName }} {{ user.lastName }}</span>
            <span style="height: 2.5rem; position: relative; left: 1rem">
              <img
                height="100%"
                v-if="iconPosition"
                :src="icons[iconPosition]" />
            </span>
          </div>

          <div style="display: flex">
            <div
              v-if="bpSession && bpSession.timeAbove80PercentHrSeconds"
              class="small-dognut mr-2"
              style="position: relative">
              <bpChart :chartdata="timeAbove80PercentHrSecondsData">
                <div>HR</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="info_icon"
                      color="white">
                      fas fa-info-circle
                    </v-icon>
                  </template>
                  <span class="tooltip_text">
                    Heart Rate tracks the minutes of activity were the player
                    working in their “Red Zone” (over 80% of their Max HR).
                  </span>
                </v-tooltip>
              </bpChart>
            </div>
            <div
              v-if="bpSession && bpSession.workload"
              class="small-dognut mr-2"
              style="position: relative">
              <bpChart :chartdata="workloadData">
                <div>TRIMPs</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="info_icon"
                      color="white">
                      fas fa-info-circle
                    </v-icon>
                  </template>
                  <span class="tooltip_text">
                    TRIMPs, or Training Impulses, is just simply a unit of
                    Workload. TRIMPs is a product of both session intensity
                    (Number of Sprints, Percentage at High Speed, Speed Zones)
                    and volume (Distance) performed by an athlete during his/her
                    session.
                  </span>
                </v-tooltip>
              </bpChart>
            </div>
            <div
              v-if="bpSession && bpSession.apPercentage"
              class="small-dognut mr-2"
              style="position: relative">
              <bpChart :chartdata="apData">
                <div>AP</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="info_icon"
                      color="white">
                      fas fa-info-circle
                    </v-icon>
                  </template>
                  <span class="tooltip_text">
                    Active Participation measures exactly how much time players
                    are active vs. inactive in a session. In other words, we
                    show how much time the players are physically moving vs.
                    standing still.
                  </span>
                </v-tooltip>
              </bpChart>
            </div>
            <div
              v-if="bpSession && bpSession.distanceMeters"
              class="small-dognut mr-2"
              style="position: relative">
              <bpChart :chartdata="distanceData">
                <div>Distance</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="info_icon"
                      color="white">
                      fas fa-info-circle
                    </v-icon>
                  </template>
                  <span class="tooltip_text">
                    Distance measures the volume of meters covered by an athlete
                    during his/her session.
                  </span>
                </v-tooltip>
              </bpChart>
            </div>
            <div
              v-if="eventReport !== undefined"
              class="small-dognut mr-2"
              style="position: relative">
              <bpChart :chartdata="eventReportChartData">
                <span>RPE</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="info_icon"
                      color="white">
                      fas fa-info-circle
                    </v-icon>
                  </template>
                  <span class="tooltip_text">
                    Rate of Perceived Exertion is used to measure the intensity
                    of a session.
                  </span>
                </v-tooltip>
              </bpChart>
            </div>
          </div>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import constants from "@/constants.js"
// import { apiWrapper } from "@/lib/utils"
// import beyondPulseApi from "@/api/beyondpulse.api.js"
import firebaseApi from "@/api/firebase.api.js"
import moment from "moment"
import bpChart from "./bpChart"

export default {
  name: "EventDetailUserListRow",
  components: {
    bpChart,
  },
  props: ["user", "action", "event", "biometricData"],
  data() {
    return {
      receivedEvent: this.event,
      icons: constants.icons,
      eventReport: undefined,
      eventReportChartData: null,
      bpSession: null,
      METRIC_COLOR: {
        TIMEABOVE80PERCENTHRSECONDS: ["#E17070", "#D04A4A", "#CA3131"],
        AP_PERCENTAGE: ["#CAAD6B", "#BA9647", "#B08625"],
        AP: ["#CAAD6B", "#BA9647", "#B08625"],
        DISTANCE: ["#92B4C0", "#699CAE", "#397F95"],
        WORKLOAD: ["#AB64EF", "#8D1DEF", "#521A91"],
      },
      METRICS: {
        TIMEABOVE80PERCENTHRSECONDS: [15, 30, 60],
        AP: [40, 60, 100],
        DISTANCE: [2500, 5000, 7500],
        WORKLOAD: [10, 20, 40],
      },
      timeAbove80PercentHrSecondsData: {
        data: null,
        color: {},
        meta: {
          showPercent: false,
          scale: 60,
          precision: 1,
          legendClass: "legend_unit__min",
        },
      },
      workloadData: {
        data: null,
        color: {},
        meta: { showPercent: false, scale: 40, precision: 2 },
      },
      apData: {
        data: null,
        color: {},
        meta: { showPercent: true, scale: 100, precision: 0 },
      },
      distanceData: {
        data: null,
        color: {},
        meta: {
          showPercent: false,
          scale: 7500,
          precision: 0,
          legendClass: "legend_unit__m",
        },
      },
    }
  },
  computed: {
    iconPosition() {
      if (this.user.coachOrPlayer === "Coach") {
        return "coach"
      }
      if (!this.user.position && this.user.position !== "") {
        return "player"
      }
      let position = this.user && this.user.position && this.user.position
      if (position === constants.positions.forward.toLowerCase()) {
        position = "striker"
      }
      return (
        String(position)[0].toLocaleLowerCase() + String(position).substring(1)
      )
    },
  },
  methods: {
    // TODO: player data doesn't load on a direct link due to the fact that reports are only loaded in squad status page
    gotToPlayerStatus(player) {
      this.$router.push({
        name: "PlayerStatus",
        params: {
          id: player.uid,
        },
      })
    },
    setDonutGraphColor(type, bpValue) {
      const sortedValue = [
        ...this.METRICS[`${type.toUpperCase()}`],
        bpValue,
      ].sort()
      let index = sortedValue.indexOf(bpValue)
      // this[`${type}Data`].meta.scale = this.METRICS[`${type.toUpperCase()}`][
      //   index
      // ];
      if (index >= sortedValue.length - 1) {
        index -= 1
      }
      this[`${type}Data`].color = {
        color: this.METRIC_COLOR[`${type.toUpperCase()}`][index],
      }
    },
    defaultImageProfile(event) {
      event.target.src = require("@/assets/icons/defaultProfileImg.png").default
    },
    // async getEventRPEs(eventId) {
    //   return await firebaseApi.getEventRPEs(eventId)
    // },
    async getBeyondPulseActivity(uid) {
      // console.warn("session uid: ", this.event.id, uid);
      // get beyond pulse stored data
      // let spSessionData
      if (this.$props?.biometricData?.uid === uid) {
        this.bpSession = this.$props.biometricData
      }
      //  else {
      //   spSessionData = await apiWrapper(
      //     firebaseApi.getBeyondPulseStoredSession,
      //     [this.receivedEvent.id, uid]
      //   )
      // }

      // if not exists
      // if (!spSessionData) {
      //   // call beyondPulse API to get the data
      //   const bpSessionData = await apiWrapper(
      //     beyondPulseApi.beyondPulsePlayerSession,
      //     [uid]
      //   )
      //   ;(
      //     (bpSessionData.data && Array.isArray(bpSessionData.data)) ||
      //     []
      //   ).forEach((bpEvent) => {
      //     if (!this.bpSession) {
      //       const spEventStart = this.receivedEvent.mEventStart
      //       const spEventEnd = this.receivedEvent.mEventEnd
      //       const bpEventStart = moment(bpEvent.started)
      //       const bpEventEnd = moment(bpEvent.ended)

      //       if (
      //         (spEventStart.isBefore(bpEventStart) ||
      //           spEventStart.isAfter(bpEventStart)) &&
      //         spEventEnd.isAfter(bpEventStart) &&
      //         spEventStart.isBefore(bpEventEnd) &&
      //         (spEventEnd.isBefore(bpEventEnd) ||
      //           spEventEnd.isAfter(bpEventEnd))
      //       ) {
      //         this.bpSession = bpEvent

      //         // store bp session in sp database
      //         apiWrapper(firebaseApi.storeBeyondPulseSession, [
      //           this.receivedEvent.id,
      //           uid,
      //           this.bpSession,
      //         ])
      //       }
      //     }
      //   })
      // } else {
      // this.bpSession = spSessionData
      // }

      if (this.bpSession) {
        // heart rate data (timeAbove80PercentHrSeconds)
        this.timeAbove80PercentHrSecondsData.data =
          this.bpSession.timeAbove80PercentHrSeconds / 60
        this.setDonutGraphColor(
          "timeAbove80PercentHrSeconds",
          this.timeAbove80PercentHrSecondsData.data
        )
        // workload data (TRIMP)
        this.workloadData.data = this.bpSession.workload
        this.setDonutGraphColor("workload", this.bpSession.workload)
        // ap data
        this.apData.data = this.bpSession.apPercentage
        this.setDonutGraphColor("ap", this.bpSession.apPercentage)
        // distance data
        this.distanceData.data = this.bpSession.distanceMeters
        this.setDonutGraphColor("distance", this.bpSession.distanceMeters)
      }
    },
  },
  async created() {
    const eventEnd = moment(
      this.receivedEvent.date + " " + this.receivedEvent.end,
      "dddd, MMMM Do YYYY h:mm a"
    )
    const eventStart = moment(
      this.receivedEvent.date + " " + this.receivedEvent.start,
      "dddd, MMMM Do YYYY h:mm a"
    )

    if (
      this.user?.coachOrPlayer === "Player" &&
      // this.user.beyondPulse &&
      eventEnd.isBefore()
    ) {
      this.eventReport = await firebaseApi.getEventRPEs(
        this.receivedEvent.id,
        this.user.uid
      )

      // this.event.mEventStart = eventStart
      this.receivedEvent.mEventStart = eventStart
      // this.event.mEventEnd = eventEnd
      this.receivedEvent.mEventEnd = eventEnd
      if (typeof this.eventReport === "object") {
        this.eventReport = this.eventReport.overall
        // const individualReportScores = this.eventReport.individualScores;
      }

      let color = ""

      if (this.eventReport > 0 && this.eventReport <= 3) {
        color = "#02c905"
      } else if (this.eventReport > 3 && this.eventReport <= 6) {
        color = "#eded02"
      } else if (this.eventReport > 6 && this.eventReport <= 8) {
        color = "#ff9800"
      } else if (this.eventReport > 8) {
        color = "#ed0202"
      }

      this.eventReportChartData = {
        data: this.eventReport,
        color: { color },
        meta: { showPercent: false, precision: 1, scale: 10 },
        // borderWidth: [0, 0],
        // data: [this.eventReport, 10 - this.eventReport]
      }
      await this.getBeyondPulseActivity(this.user.uid)
    }
  },
}
</script>

<style lang="sass">
@import '@/assets/sass/_variables.sass'

.small-dognut
  max-height: 120px
  max-width: 120px

.info_icon
  font-size: 0.8rem !important
.tooltip_text
  max-width: 16rem !important
  display: inline-block
  font-size: larger

.event-detail-user-list-row
  padding: 0px 10px !important
  min-height: 60px
  margin: 10px auto
  &:hover
    cursor: pointer
  .list-item
    border-bottom: 1px solid white
    display: table
    width: 100%
    max-height: 60px
    height: 60px
    padding: 5px
    span
      display: table-cell
      vertical-align: middle
      .user-icon
        height: 40px
  .legend_unit
    &__m::after
      content: " m"
      position: relative
      top: -2px
    &__min::after
      content: " min"
      position: relative
      top: -2px
</style>
